<template>
  <v-dialog v-model="dialog" max-width="850" persistent transition="dialog-bottom-transition" scrollable>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar flat dark color="secondary">
            <v-toolbar-title>Set Sebaran Satuan Pendidikan Kepala Sekolah Tiap Jenjang</v-toolbar-title>
            <v-spacer />
            <v-btn right icon dark @click="close">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card-title>
        <v-card-text class="pb-0 black--text my-5">
          <template v-for="(item, i) in detail.psp_peringkat_jenjangs">
            <v-row :key="item.psp_peringkat_jenjang_id">
              <v-col cols="12" md="6">
                <v-list-item class="px-0">
                  <v-list-item-avatar color="warning" size="60">
                    <v-icon dark>mdi-google-classroom</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content class="py-0 px-1">
                    <span class="caption grey--text">Jenjang</span>
                    <div class="subtitle-2 blue--text">
                      {{ $getDeepObj(item, 'm_jenjang.singkat') }}
                      ({{ $getDeepObj(item, 'm_jenjang.keterangan') }})
                    </div>
                  </v-list-item-content>
                </v-list-item>
                <div class="mt-1">
                  <span class="caption grey--text">
                    Ajuan Persentase dari Dinas Daerah
                    <span class="blue--text">
                      (Negeri {{ $getDeepObj(item, 'persen_negeri') || 0 }}% dan Swasta
                      {{ $getDeepObj(item, 'persen_swasta') || 0 }}%)
                    </span>
                  </span>
                  <v-text-field
                    type="number"
                    outlined
                    dense
                    v-model="form[i]['kuota']"
                    :rules="[
                      (v) =>
                        Number(v) <=
                          Number($getDeepObj(item, 'jml_kasek_negeri') || 0) +
                            Number($getDeepObj(item, 'jml_kasek_swasta') || 0) ||
                        'Sebaran Satuan Pendidikan yang diberikan melebihi dari jumlah total kandidat KS yang ada di daerah tersebut',
                      (v) => !!v || 'Sebaran Satuan Pendidikan wajib diisi',
                    ]"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <v-list-item class="px-0">
                  <v-list-item-content class="py-0 px-1">
                    <span class="caption grey--text">Informasi Kandidat saat ini</span>
                    <div>
                      Jumlah Sekolah Negeri
                      {{ $getDeepObj(item, 'jml_kasek_negeri') || 0 }} dan Jumlah Sekolah Swasta
                      {{ $getDeepObj(item, 'jml_kasek_swasta') || 0 }}
                    </div>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item class="mt-6 px-0" v-if="form && form[i] && form[i]['kuota']">
                  <v-list-item-content class="py-0 px-1">
                    <span class="caption grey--text"
                      >Informasi Pembagian Sebaran Satuan Pendidikan KS (dari sistem)</span
                    >
                    <v-alert color="#D3EAFD" light>
                      <b>Sebaran Satuan Pendidikan Negeri</b>:
                      <b class="blue--text">
                        {{
                          Math.ceil(Number(($getDeepObj(item, 'persen_negeri') || 0) / 100) * Number(form[i]['kuota']))
                        }} </b
                      ><br />
                      <b>Sebaran Satuan Pendidikan Swasta</b>:
                      <b class="blue--text">
                        {{
                          Number(form[i]['kuota']) -
                            Math.ceil(
                              Number(($getDeepObj(item, 'persen_negeri') || 0) / 100) * Number(form[i]['kuota'])
                            )
                        }}
                      </b>
                    </v-alert>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>
          </template>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small text @click="close">
            Batal
          </v-btn>
          <v-btn class="ma-2" color="success" elevation="1" @click="save">
            Simpan Data
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
export default {
  name: 'PopupNilai',
  props: {
    detail: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      dialog: false,
      valid: true,
      form: {},
    };
  },

  methods: {
    open() {
      this.dialog = true;
      this.form = {};

      const jenjang = (this.detail && this.detail.psp_peringkat_jenjangs) || [];
      jenjang.forEach((item, index) => {
        this.$set(this.form, index, {
          psp_peringkat_jenjang_id: item && item.psp_peringkat_jenjang_id,
          kuota: Number(item && item.kuota) || 0,
        });
      });
    },

    close() {
      this.dialog = false;
    },

    async save() {
      await this.$refs.form.validate();
      if (this.valid) this.$emit('save', this.form);
    },
  },
};
</script>
